import type { HuntPlanDetail } from './types'

/**
 * Whether the viewer leads this hunt: a participant whose `isLeader` (the
 * hunt-level role, not the team role) is set, matched on the viewer's own id.
 * `!!viewerId` first: the host passes undefined while auth is unresolved, and a
 * roster entry whose id never came through the mapper is undefined too, so
 * without the guard an unidentified viewer would match.
 */
export function viewerLeadsHunt(
  detail: Pick<HuntPlanDetail, 'participants'> | undefined,
  viewerId: string | undefined,
): boolean {
  return !!viewerId && !!detail?.participants.some((p) => p.isLeader && p.userId === viewerId)
}
